import React from 'react';
import {
  Button,
  Checkbox,
  Grid,
  GridProps,
  Stack,
  StackProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import { TP_COLORS } from '../../../../../constants';
import { THomeworkQuiz } from '../../../../../store/V2/HomeworksSlice';
import { IQuiz } from '../../../../../store/QuizSlice';
import { getQuiztopiyaState } from '../../../../../store/V2/QuiztopiyaSlice';
import { useAppSelector } from '../../../../../hooks';
import BasicLoader from '../../../../../components/Loaders/BasicLoader';
import { getQuizLink } from '.';

const gridProps: GridProps = {
  marginTop: '40px',
  rowGap: '10px',
  minWidth: '500px',
  paddingRight: 2,
  sx: {
    maxHeight: 'calc(100vh - 320px)',
    overflowY: 'auto',
  },
};

const stackProps: StackProps = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  sx: {
    padding: '20px',
    borderRadius: '5px',
    border: '1px solid #E2E8F0',
  },
};

const loadingStackProps: StackProps = {
  alignItems: 'center',
  justifyContent: 'center',
  height: '500px',
};

const titleTypoProps: TypographyProps = {
  fontSize: '14px',
  color: TP_COLORS.gray.darken,
};

const subTitleTypoProps: TypographyProps = {
  fontSize: '18px',
  color: TP_COLORS.gray.darken,
};

interface QuizzesListProps {
  quizzes: THomeworkQuiz[];
  handleQuizSelect: (quiz: IQuiz) => void;
}

const QuizzesList: React.FC<QuizzesListProps> = ({
  quizzes,
  handleQuizSelect,
}) => {
  // Store
  const { adminQuizzes, quizzesStatus } = useAppSelector(getQuiztopiyaState);

  const isLoading = quizzesStatus === 'loading';

  return (
    <div>
      <Typography fontSize="14px" color="#475569">
        Select the quiz you want to share with your student, you can view the
        quiz on Quiztopiya platform before sharing with students.
      </Typography>
      {isLoading && (
        <Stack {...loadingStackProps}>
          <BasicLoader />
        </Stack>
      )}
      {!isLoading && adminQuizzes.length === 0 && (
        <Stack {...loadingStackProps}>
          <Typography fontSize="14px">
            Select curriculum, grade subject and subject level
          </Typography>
        </Stack>
      )}
      {!isLoading && adminQuizzes.length > 0 && (
        <Grid container {...gridProps}>
          {adminQuizzes.map((quiz, index) => (
            <Grid item key={index} xs={12}>
              <Stack {...stackProps}>
                <Grid container>
                  <Grid item xs={2}>
                    <Typography {...titleTypoProps}>Quiz</Typography>
                    <Typography {...subTitleTypoProps}>
                      {(index + 1).toString().padStart(2, '0')}
                    </Typography>
                  </Grid>
                  <Grid item xs={3.5}>
                    <Typography {...titleTypoProps}>
                      Difficulty Level
                    </Typography>
                    <Typography {...subTitleTypoProps}>
                      {quiz.difficulty}
                    </Typography>
                  </Grid>
                  <Grid item xs={3.5}>
                    <Typography {...titleTypoProps}>No of Question</Typography>
                    <Typography {...subTitleTypoProps}>
                      {quiz.noOfQuestions}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      color="inherit"
                      href={getQuizLink(quiz)}
                      target="_blank"
                      sx={{
                        fontSize: '14px',
                        fontWeight: '600',
                        backgroundColor: '#F1F5F9',
                        padding: '5px',
                        borderRadius: '5px',
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                  <Grid item xs={1}>
                    <Checkbox
                      checked={quizzes.some((item) => item._id === quiz._id)}
                      onChange={() => handleQuizSelect(quiz)}
                    />
                  </Grid>
                </Grid>
              </Stack>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default QuizzesList;
